import React, { useEffect, useState } from "react";
import { Row, Col } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { orderBy } from "lodash";

import PieChart from "../Charts/PieChart";
import Funnel from "../Charts/Funnel";
import CountryMap from "../Charts/CountryMap";
import { setAnalytics } from "../../store/actions/analyticsActions";

const SessionAnalytics = (props) => {
  const dispatcher = useDispatch();
  const domain = useSelector((state) => state.domains.currentDomain);
  const analytics = useSelector((state) => state.analytics.analytics);
  const [deviceTypeCount, setdeviceTypeCount] = useState(null);
  const [browserTypeCount, setbrowserTypeCount] = useState(null);
  const [platformTypeCount, setplatformTypeCount] = useState(null);
  const [topReferrerCount, settopReferrerCount] = useState(null);
  const [countryWise, setcountryWise] = useState(null);
  const [keywordStatusWise, setkeywordStatusWise] = useState(null);

  useEffect(() => {
    if (domain) {
      dispatcher(setAnalytics(domain._id));
    }
  }, [domain]);

  useEffect(() => {
    if (analytics) {
      setdeviceTypeCount(
        analytics.deviceTypeCount.map((device) => {
          return {
            id: device._id.deviceType,
            label: device._id.deviceType,
            value: device.count,
          };
        })
      );
      setplatformTypeCount(
        analytics.platformTypeCount.map((platform) => {
          return {
            id: platform._id.platformType,
            label: platform._id.platformType,
            value: platform.count,
          };
        })
      );
      setbrowserTypeCount(
        analytics.browserTypeCount.map((browser) => {
          return {
            id: browser._id.browserType,
            label: browser._id.browserType,
            value: browser.count,
          };
        })
      );
      let sortTopReferers = orderBy(
        analytics.topReferrerCount,
        ["count"],
        ["desc"]
      ).slice(0, 5);
      settopReferrerCount(
        sortTopReferers.map((browser) => {
          return {
            id:
              browser._id.topRefererCount === ""
                ? "No Referer"
                : browser._id.topRefererCount,
            label:
              browser._id.topRefererCount === ""
                ? "No Referer"
                : browser._id.topRefererCount,
            value: browser.count,
          };
        })
      );
      setcountryWise(
        analytics.countryWise.map((country) => {
          return {
            id: country._id.countryWise,
            value: country.count,
          };
        })
      );
      setkeywordStatusWise(
        analytics.keywordStatusWise.map((keyword) => {
          return {
            id:
              keyword._id.rankStatusWise === "no_change"
                ? "no impact"
                : keyword._id.rankStatusWise,
            label:
              keyword._id.rankStatusWise === "no_change"
                ? "no impact"
                : keyword._id.rankStatusWise,
            value: keyword.count,
          };
        })
      );
    }
  }, [analytics]);

  return (
    <>
      <Row>
        <Col span={12} style={{ paddingRight: "15px" }}>
          <PieChart
            data={deviceTypeCount}
            title="Vistis By Device Type"
            scheme="accent"
          />
        </Col>
      </Row>
      <br />
      <Row>
        <Col span={12} style={{ paddingRight: "15px" }}>
          <PieChart
            data={platformTypeCount}
            title="Vistis By Platform Type"
            scheme="paired"
          />
        </Col>
        <Col span={12} style={{ paddingRight: "15px" }}>
          <PieChart
            data={browserTypeCount}
            title="Vistis By Browser Type"
            scheme="set2"
          />
        </Col>
      </Row>
      <br />
      <Row>
        <Col span={12} style={{ paddingRight: "15px" }}>
          <CountryMap title="Visits by country" data={countryWise} />
        </Col>
        <Col span={12} style={{ paddingRight: "15px" }}>
          <Funnel data={topReferrerCount} title="Top Five Referer" />
        </Col>
      </Row>
    </>
  );
};

export default SessionAnalytics;
